/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約値情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoElecConvalInfo {
    /**
     * 契約電流：英数字<br>　コード変換マスターテーブル.画面項目ID「C401120」のユーザコードを設定
     */
    conAmpA?: string;
    /**
     * 契約電流名称：全半角混在
     */
    conAmpAAname?: string;
    /**
     * 契約容量
     */
    conCapKva?: number;
    /**
     * 契約電力
     */
    conEleKw?: number;
    /**
     * 再エネ賦課金減免有無：英数字<br>　コード変換マスターテーブル.画面項目ID「C401140」のユーザコードを設定
     */
    redtaxFlg?: string;
    /**
     * 再エネ賦課金減免有無名称：全半角混在
     */
    redtaxFlgAname?: string;
    /**
     * 再エネ賦課金減免率：英数字<br>　コード変換マスターテーブル.画面項目ID「C401150」のユーザコードを設定
     */
    redtaxPrcnt?: string;
    /**
     * 再エネ賦課金減免率名称：全半角混在
     */
    redtaxPrcntAname?: string;
    /**
     * 再エネ賦課金減免開始日：日付(yyyyMMdd)
     */
    redStrtDate?: string;
    /**
     * 再エネ賦課金減免終了日：日付(yyyyMMdd)
     */
    redEndDate?: string;
}

